import { gql } from '../../gql';

export const TESTER_PROFILE = gql(`
  fragment TesterProfile on Profile {
    id
    type
    name
    lastName
    firstName
    contactAddressId
    contactAddress {
      id
      street1
      street1
      city
      state
      zip
    }
    billingAddressId
    billingAddress {
      id
      street1
      street1
      city
      state
      zip
    }
    phones {
      id
      subType
      value
    }
    emails {
      id
      subType
      value
    }
    perms
    user {
      profileId
      email
    }
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);
// roles

export const TESTER_CREDENTIALS = gql(`
  fragment TesterCredentials on Credential {
    id
    type
    issuer
    value
    city
    state
    issueDate
    expireDate
    isDefault
    perms
    created
    updated
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const TESTER_GAUGES = gql(`
  fragment TesterGauges on Gauge {
    id
    gaugeNumber
    calibrationDate
    isDefault
    perms
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`);

export const GET_MY_TESTER_PROFILE = gql(
  `
  query GetMyProfile {
    me {
      ...TesterProfile
      credentials(where: { type: "BACKFLOW", archived: null }) {
        ...TesterCredentials
      }
      backflowTester {
        gauges(where: { archived: null }) {
          ...TesterGauges
        }
      }
    }
  }
`,
  [TESTER_PROFILE, TESTER_CREDENTIALS, TESTER_GAUGES]
);
